import { Autocomplete, Box, CircularProgress, Stack, TextField } from '@mui/material';
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const CustomerAutoComplete = ({ selectedCustomer, customerDropdown, setSelectedCustomer }) => {
    const { t } = useTranslation("translations");
    const loading = useSelector((store) => store.summarydashboard.loading.customers);

    return (
        <Box sx={{ width: 500 }}>
            <Autocomplete
                autoHighlight
                fullWidth
                id="customer-dropdown"
                value={selectedCustomer}
                onChange={(event, newValue) => setSelectedCustomer(newValue)}
                options={customerDropdown}
                getOptionLabel={(option) => option.name}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label={t("Customer Selection")}
                        variant="outlined"
                        InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                                <React.Fragment>
                                    {loading ? <CircularProgress color="secondary" size={20} /> : null}
                                    {params.InputProps.endAdornment}
                                </React.Fragment>
                            ),
                        }}
                    />
                )}
            />
        </Box>
    );
}

export default CustomerAutoComplete
